import { ReactElement, ReactNode } from "react";
import { IconProps } from "@phosphor-icons/react";
import { useShallow } from "zustand/shallow";

import { useBoundStore } from "@/app/store";
import { Drawer } from "./Drawer";
import { Modal } from "./Modal";

interface DrawerAndModalProps {
  actionsDisabled?: boolean;
  children?: ReactNode;
  icon?: ReactElement<IconProps>;
  id: string;
  isDismissable?: boolean;
  triggerProps?: { isDisabled?: boolean };
  title?: string;
  closeLabel?: string;
  confirmLabel?: string;
  onConfirm?: () => void;
  externalState?: {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
  };
}

export function DrawerAndModal({
  actionsDisabled,
  id,
  icon,
  isDismissable,
  children,
  triggerProps,
  title,
  closeLabel,
  confirmLabel,
  onConfirm,
  externalState,
}: DrawerAndModalProps) {
  const { deviceType } = useBoundStore(useShallow((state) => ({ deviceType: state.device.type })));

  return deviceType === "mobile" ? (
    <Drawer
      icon={icon}
      id={id}
      isDismissable={isDismissable}
      children={children}
      triggerProps={triggerProps}
      externalState={externalState}
    />
  ) : (
    <Modal
      actionsDisabled={actionsDisabled}
      icon={icon}
      id={id}
      isDismissable={isDismissable}
      children={children}
      triggerProps={triggerProps}
      title={title}
      closeLabel={closeLabel}
      confirmLabel={confirmLabel}
      onConfirm={onConfirm}
      externalState={externalState}
    />
  );
}
